import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalHelper } from '../Common/global.service';

@Injectable({
  providedIn: 'root'
})
export class StudentPortalService {

  constructor(private globalHelper:GlobalHelper, private httpclient: HttpClient) { }

  GetStudentFeeChallan():Observable<any>{   
    // let data='ObjEnquiry=' +strData;  
  var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl+'StudentPortal/GetStudentFeeChallan?',{headers:reqHeader});

}
  GetStudentHomeWork():Observable<any>{   
    // let data='ObjEnquiry=' +strData;  
  var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl+'StudentPortal/GetStudentHomeWork?',{headers:reqHeader});

}
GetStudentHomeWorkFile(strData):Observable<any>{   
    
   var formData = new FormData();
        formData.append("obj", strData);
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'StudentPortal/GetStudentHomeWorkFile?',formData);

}
SaveStudentHomeWork(data, FileUpload):Observable<any>{   
  var formData = new FormData();
        formData.append("objstr", data);
        formData.append("FileUpload", FileUpload);
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'StudentPortal/SaveStudentHomeWork?',formData);

}
GetStudentDetailsByStudentID_StudentPortal():Observable<any>{   
  //  let data='ObjEnquiry=' +strStudent;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'StudentPortal/GetStudentDetailsByStudentID?',{headers:reqHeader});

}
GetStudentDetails_StudentPortal():Observable<any>{   
  var formData = new FormData();
       
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'StudentPortal/GetStudentDetails_StudentPortal?',formData);

}
GetFeeInstallmentComponent(ClassID, StudentID):Observable<any>{   
  var formData = new FormData();
        formData.append("ClassID", ClassID);
        formData.append("StudentID", StudentID);
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'StudentPortal/GetFeeReceiptInstallmentComponent_StudentPortal?',formData);

}
GetPaymentReceipt(objReceipt):Observable<any>{   
  var formData = new FormData();
        formData.append("objReceipt", objReceipt);
     
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'StudentPortal/SearchPaymentReceipt?',formData);

}
GetStudentAttendanceDetails_StudentPortal(AtMonth, AtYear):Observable<any>{   
  var formData = new FormData();
        formData.append("AtMonth", AtMonth);
        formData.append("AtYear", AtYear);
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'StudentPortal/GetStudentAttendanceDetails_StudentPortal?',formData);

}
GetStudentAttendanceYearly_StudentPortal(objMonthlyAttendance):Observable<any>{   
  var formData = new FormData();
        formData.append("objMonthlyAttendance", objMonthlyAttendance);
     
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'StudentPortal/GetStudentAttendanceYearly_StudentPortal?',formData);

}
GetStudentDetailsForFeePayment_StudentPoratl():Observable<any>{   
  var formData = new FormData();
      
    
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'StudentPortal/GetStudentDetailsForFeePayment_StudentPoratl?',formData);

}
GetAcademics():Observable<any>{   
  var formData = new FormData();
       
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'StudentPortal/GetStudentAcademics?',formData);

}
GetFeeInstallmentComponent_StudentPortal(ClassID, StudentID):Observable<any>{   
  var formData = new FormData();
        formData.append("ClassID", ClassID);
        formData.append("StudentID", StudentID);
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'StudentPortal/GetFeeInstallmentComponent_StudentPortal?',formData);

}
onSubmit(BasicDetails, FeeList):Observable<any>{   
 var formData = new FormData();
        formData.append("BasicDetails", BasicDetails);
        formData.append("FeeList", FeeList);
return this.httpclient.post<any>('http://localhost:44397/PaymentGateway/PaymentConfirmation.aspx?',formData);

}
}
